<template>
    <div class="form-field-datetime">
        <label :for="id" :class="labelClasses">{{ label }}</label>
        <div class="mt-2.5">
            <input
                type="datetime-local"
                :name="id"
                :id="id"
                :placeholder="placeholder"
                :value="formattedValue"
                @input="handleDateTimeInput"
                :class="inputClasses"
                @focus="
                    (event) => {
                        $emit('focused', {field, value: event.target.value, event});
                    }
                "
            />
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'FormFieldDateTime',
    props: {
        id: {
            required: false,
            type: String,
            default: null,
        },
        label: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: false,
            type: String,
            default: null,
        },
        value: {
            required: false,
            type: [Date, String],
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        labelClasses() {
            const cls = {};
            cls['text-md block font-medium leading-6 text-gray-900'] = true;
            return cls;
        },
        inputClasses() {
            const cls = {};
            cls['block w-full rounded-md border-0 px-4 py-2.5 shadow-xs'] = true;
            cls['sm:text-sm sm:leading-6'] = true;
            cls['text-gray-900 placeholder:text-gray-400'] = true;
            cls['ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-sky-600'] = true;
            return cls;
        },
        formattedValue() {
            if (!this.value) return '';
            return dayjs(this.value).format('YYYY-MM-DDTHH:mm');
        },
    },
    methods: {
        handleDateTimeInput(event) {
            if (!event.target.value) return this.$emit('update', {field: this.field, value: null, event});
            const newDateTime = new Date(event.target.value);
            this.$emit('update', {field: this.field, value: newDateTime, event});
        },
    },
};
</script>
